import type { ComputedRef, MaybeRefOrGetter } from 'vue';
import type { DisplayTemplateAst, FieldSelection } from '#layers/data-model';
import type { ResolvedMonospaceCollection } from '#layers/data-model/types/schema/resolved-schema';
import { computed, toValue } from 'vue';
import { resolveCollectionDisplayTemplateFields } from '#layers/data-model/utils/display-template-field-selection';
import { useFieldSelectionContexts } from '~/composables/use-field-selection-contexts';
import { idFieldSelectionToFieldSelection } from '~/utils/id-field-selection-to-field-selection';

export function useDisplayTemplateFieldSelection(
	collection: MaybeRefOrGetter<ResolvedMonospaceCollection | undefined>,
	displayTemplate?: MaybeRefOrGetter<DisplayTemplateAst | undefined>,
): ComputedRef<FieldSelection> {
	const { fieldSelectionCtx, idCtx } = useFieldSelectionContexts();

	return computed<FieldSelection>(() => {
		const col = toValue(collection);
		if (!col) return ['*'];

		const idSelection = resolveCollectionDisplayTemplateFields(
			col,
			fieldSelectionCtx,
			toValue(displayTemplate),
		);

		return idFieldSelectionToFieldSelection(idSelection, idCtx);
	});
}
